import GenericCompanyCard from '@assets/images/companyCards/generic-dark.svg';
import GenericCSVCompanyCardLarge from '@assets/images/companyCards/large/generic-csv-dark-large.svg';
import GenericCompanyCardLarge from '@assets/images/companyCards/large/generic-dark-large.svg';
import ExpensifyApprovedLogo from '@assets/images/subscription-details__approvedlogo.svg';
import EmptyStateBackgroundImage from '@assets/images/themeDependent/empty-state_background-fade-dark.png';
import ExampleCheckEN from '@assets/images/themeDependent/example-check-image-dark-en.png';
import ExampleCheckES from '@assets/images/themeDependent/example-check-image-dark-es.png';
import WorkspaceProfile from '@assets/images/workspace-profile.png';
import type IllustrationsType from '@styles/theme/illustrations/types';

const illustrations = {
    EmptyStateBackgroundImage,
    ExampleCheckEN,
    ExampleCheckES,
    WorkspaceProfile,
    ExpensifyApprovedLogo,
    GenericCompanyCard,
    GenericCompanyCardLarge,
    GenericCSVCompanyCardLarge,
} satisfies IllustrationsType;

export default illustrations;
